<template>
  <section class="content-header">
    <h1>{{ $route.name }}</h1>
    <!--<h1>Dashboard <small>Version 2.0</small></h1>-->
    <!--<ol class="breadcrumb">-->
      <!--<li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>-->
      <!--<li class="active">Dashboard</li>-->
    <!--</ol>-->
  </section>
</template>

<script>
export default {
  name: 'AltContentHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/AltContentHeader.vue